module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-project-types-for-responsibles"
  }, [(!_vm.loading) ? _c('div', [(_vm.employees && !_vm.loading && _vm.$auth.user().roles[0].name !== 'project-responsible') ? _c('div', {
    staticClass: "employees-wrapper"
  }, _vm._l((_vm.employees), function(employee) {
    return _c('div', {
      key: 'employee_' + employee.relation_id
    }, [_c('div', {
      staticClass: "employee",
      class: {
        'selected': _vm.selectedEmployee && _vm.selectedEmployee.relation_id === employee.relation_id
      },
      on: {
        "click": function($event) {
          _vm.selectedEmployee = employee
        }
      }
    }, [_vm._v("\n                    " + _vm._s(employee.first_name) + " " + _vm._s(employee.last_name) + "\n                ")])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.selectedEmployee && _vm.$auth.user().roles[0].name !== 'project-responsible') ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vælg en opgaveansvarlig for at se et overblik over hans/hendes værdikæde her\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.selectedEmployee && _vm.$auth.user().roles[0].name === 'project-responsible') ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vi kunne ikke finde din værdikæde. Kontakt venligst din administrator.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedEmployee) ? _c('div', [_c('responsible-valuechain-single', {
    attrs: {
      "data": _vm.selectedEmployee
    }
  })], 1) : _vm._e()])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d2a8562"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsibles/learning/responsibleValuechain.vue
// module id = 800
// module chunks = 0